import React, { useRef } from "react"
import styled from "styled-components"
import { getCssSizeValue, getHtmlFromRedactorField } from "@/utils/utils"
import Text from "@/components/common/Text"
import { useTextShuffle } from "@/animations/TextShuffle"
import StatsLine from "@/components/Stats/Line"
import { BREAKPOINTS } from "@/styles/themeSettings"

const Wrapper = styled.div`
	--local-padding-x: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	background-color: ${({ theme }) => theme.colors.platinum};
	display: flex;
	flex-direction: column;
	padding: ${getCssSizeValue(14, BREAKPOINTS.MOBILE)} var(--local-padding-x);
	min-height: ${getCssSizeValue(180, BREAKPOINTS.MOBILE)};

	.desc {
		margin-bottom: 50px;
	}

	.number {
		text-align: end;
	}

	.to-right {
		margin-top: auto;
		margin-left: auto;
		bottom: 0;
		margin-bottom: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		--local-padding-x: ${getCssSizeValue(15, BREAKPOINTS.TABLET)};
		padding: ${getCssSizeValue(40, BREAKPOINTS.TABLET)} var(--local-padding-x);
		min-height: ${getCssSizeValue(280, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		--local-padding-x: ${getCssSizeValue(32)};
		min-height: ${getCssSizeValue(280)};
		padding: ${getCssSizeValue(32)} var(--local-padding-x);

		.to-right {
			margin-bottom: ${getCssSizeValue(24)};
		}
	}
`

const Line = styled(StatsLine)`
	position: relative;
	width: 100%;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: calc(100% + var(--local-padding-x) * 2);
		left: calc(var(--local-padding-x) * -1);
	}
`

function formatNumber(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}

const Statistic = ({ data, line = true }) => {
	const description = getHtmlFromRedactorField(data?.description || "")
	const number = formatNumber(data?.number || 0)
	const noun = data?.noun || ""
	const displayGapBetweenNumberAndNoun = data?.displayGapBetweenNumberAndNoun || false
	const id = `statistic-${data?.id || ""}`
	const TextRef = useRef()
	// const isDesktop = useIsDesktop()
	// const text = isDesktop ? `${number} ${noun}` : number
	const text = displayGapBetweenNumberAndNoun ? `${number} ${noun}` : `${number}${noun}`
	const chars = "0123456789"

	useTextShuffle({
		el: TextRef,
		onInView: true,
		text,
		chars,
	})

	return (
		<Wrapper id={id} className="col-mobile-8 col-tablet-4 col-desktop-6">
			<Text as="div" className="typo-borna-09 desc" dangerouslySetInnerHTML={description} />
			<Text key={text} ref={TextRef} className="typo-borna-56 to-right number">
				{chars}
			</Text>
			{line && <Line />}
		</Wrapper>
	)
}

export default Statistic
